import {client} from '../util/createRestApiClient';

const base = "ELIUser/";
export default () => ({
    loginUser: (params) => client.request({
      method: 'POST',
      url: base + 'Login',
      data: params
    }),
    loginUserRetiree: (params) => client.request({
      method: 'POST',
      url: base + 'LoginRetiree',
      data: params
    }),
    loginAzureService: (params) => {
      console.log(params);
     return  client.request({
    method: 'POST',
    url: base +'LoginAzure',
    data: { username: params.username },
    headers: {
      Check: params.password
     }
    })
    },
    refreshToken: () => client.request(
      {
        method: 'POST',
        url: base + 'RefreshToken'
      }
    ) 
  }
);

